import { render, staticRenderFns } from "./formField.vue?vue&type=template&id=67fa9ff4&scoped=true"
import script from "./formField.vue?vue&type=script&lang=js"
export * from "./formField.vue?vue&type=script&lang=js"
import style0 from "./formField.vue?vue&type=style&index=0&id=67fa9ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fa9ff4",
  null
  
)

export default component.exports